export const JOB_TYPES = Object.freeze({
  PRODUCT_LIBRARY: 'productLibrary',
  WORK_VIEWER_LIBRARY: 'workViewerLibrary',
  STANDARD_TEMPLATE: 'standardTemplate',
});

export const PRODUCT_TEMPLATE_JOB_TYPES = Object.freeze([
  JOB_TYPES.STANDARD_TEMPLATE,
]);
